"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const notistack_1 = require("notistack");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
require("./global.css");
require("@connect2ic/core/style.css");
const explorer_1 = __importDefault(require("./pages/explorer/explorer"));
const ledgerAccountSpecific_1 = __importDefault(require("./pages/accountSpecific/ledgerAccountSpecific"));
const governance_1 = __importDefault(require("./pages/governance/governance"));
const updatedGovernance_1 = __importDefault(require("./pages/updatedGovernance/updatedGovernance"));
const stakes_1 = __importDefault(require("./pages/stakes/stakes"));
const proposals_1 = __importDefault(require("./pages/proposals/proposals"));
const ledgerTransactionSpecific_1 = __importDefault(require("./pages/transactionSpecific/ledgerTransactionSpecific"));
const governanceAccountSpecific_1 = __importDefault(require("./pages/governanceAccountSpecific/governanceAccountSpecific"));
const authProvider_1 = require("./components/authProvider/authProvider");
const SessionProvider_1 = require("./components/authProvider/SessionProvider");
const proposalsSpecific_1 = __importDefault(require("./pages/proposalsSpecific/proposalsSpecific"));
const Layout_1 = require("./components/layout/Layout");
const stakesSpecific_1 = __importDefault(require("./pages/stakesSpecific/stakesSpecific"));
const aboutUs_1 = __importDefault(require("./pages/aboutUs"));
const logIn_1 = __importDefault(require("./pages/logIn"));
const userTransactions_1 = __importDefault(require("./pages/userTransactions/userTransactions"));
const supportTicket_1 = __importDefault(require("./pages/supportTicket"));
const recovery_1 = __importDefault(require("./pages/recovery"));
const ledgerTransactionHashSpecific_1 = __importDefault(require("./pages/hashSpecific/ledgerTransactionHashSpecific"));
const aboutUsLegacy_1 = __importDefault(require("./pages/aboutUsLegacy"));
const ScrollToTop = () => {
    const { pathname } = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};
const App = () => {
    const router = (0, react_router_dom_1.createBrowserRouter)([
        /* ---------- MAIN PAGES ---------- */
        {
            path: '/',
            element: (react_1.default.createElement(SessionProvider_1.SessionProvider, null,
                react_1.default.createElement(authProvider_1.AuthProvider, null,
                    react_1.default.createElement(ScrollToTop, null),
                    react_1.default.createElement(Layout_1.Layout, null)))),
            children: [
                {
                    path: 'aboutus',
                    element: (react_1.default.createElement(aboutUs_1.default, null)),
                },
                {
                    path: 'home',
                    element: (react_1.default.createElement(aboutUs_1.default, null)),
                },
                {
                    index: true,
                    element: (react_1.default.createElement(aboutUs_1.default, null)),
                },
                {
                    path: 'legacy',
                    element: (react_1.default.createElement(aboutUsLegacy_1.default, null)),
                },
                {
                    path: 'support',
                    element: (react_1.default.createElement(supportTicket_1.default, null)),
                },
                {
                    path: 'recovery',
                    element: (react_1.default.createElement(recovery_1.default, null)),
                },
                {
                    path: 'governance',
                    element: (react_1.default.createElement(governance_1.default, null)),
                },
                {
                    path: 'governancestats',
                    element: (react_1.default.createElement(updatedGovernance_1.default, null)),
                },
                {
                    path: 'explorer',
                    element: (react_1.default.createElement(explorer_1.default, null)),
                },
                {
                    path: '/stakes',
                    element: (react_1.default.createElement(stakes_1.default, null)),
                },
                {
                    path: '/transactions',
                    element: (react_1.default.createElement(userTransactions_1.default, null)),
                },
                {
                    path: '/proposals',
                    element: (react_1.default.createElement(proposals_1.default, null)),
                },
                {
                    path: '/login',
                    element: (react_1.default.createElement(logIn_1.default, null)),
                },
                /* ---------- SPECIFIC PAGES ---------- */
                {
                    path: '/stakes/:id',
                    element: (react_1.default.createElement(stakesSpecific_1.default, null)),
                },
                {
                    path: '/account/:id',
                    element: (react_1.default.createElement(ledgerAccountSpecific_1.default, null)),
                },
                {
                    path: '/proposals/:id',
                    element: (react_1.default.createElement(proposalsSpecific_1.default, null)),
                },
                {
                    path: '/governance/:id',
                    element: (react_1.default.createElement(governanceAccountSpecific_1.default, null)),
                },
                {
                    path: '/transaction/:txhash',
                    element: (react_1.default.createElement(ledgerTransactionSpecific_1.default, null)),
                },
                {
                    path: '/hash/:txhash',
                    element: (react_1.default.createElement(ledgerTransactionHashSpecific_1.default, null)),
                },
                {
                    path: '*',
                    element: (react_1.default.createElement(origyn_art_ui_1.Flex, { style: { minHeight: "60vh" }, gap: 32, align: "center", justify: "center", fullHeight: true, fullWidth: true, flexFlow: 'column' },
                        react_1.default.createElement("h1", null, "404"),
                        react_1.default.createElement("h4", null, "Page Not found"))),
                },
            ]
        },
    ]);
    return (react_1.default.createElement(notistack_1.SnackbarProvider, { maxSnack: 3 },
        react_1.default.createElement(react_router_dom_1.RouterProvider, { router: router })));
};
exports.default = App;
